export default "__VITE_ASSET__Btq$eV3J__"